"use strict";

exports.__esModule = true;
var _Logo = _interopRequireDefault(require("./Logo"));
exports.default = _Logo.default;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}